// Logo.tsx
import React from "react";
import { styled, Typography, useMediaQuery } from "@mui/material";
import ReactRouterLink from "./ReactRouterLink";

const LogoContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  marginRight: "0px",
});
const LogoIconImage = styled("img")({ height: "40px" });
const Logo512Image = styled("img")({
  height: "30px",
  marginLeft: "8px",
  "@media (max-width: 768px)": { display: "none" },
});
const TextUnderLogo = styled(Typography)({
  fontSize: "10px",
  marginRight: "7px",
  textAlign: "right",
  color: "#e78758",
  "@media (max-width: 768px)": { display: "none" },
});

const Logo: React.FC = () => {
  const isMobileScreen = useMediaQuery("(max-width:600px)");

  return (
    <ReactRouterLink
      to="/"
      linkElement={
        <>
          <LogoContainer>
            {!isMobileScreen && (
              <LogoIconImage src="/logoicon.png" alt="LogoIcon" />
            )}
            <Logo512Image src="/logo512.png" alt="Logo512" />
          </LogoContainer>
          <TextUnderLogo>A Toys Marketplace</TextUnderLogo>
        </>
      }
      style={{ textDecoration: "none", color: "inherit" }}
      isLinkUnderline={false}
    />
  );
};

export default Logo;
